function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import businessDomainService from '@/apps/data-platform/services/master_data/business_domain_service';
import businessSubdomainService from '@/apps/data-platform/services/master_data/business_subdomain_service';
import domain_service from '@/apps/data-platform/services/master_data/domain_service';
import rolesService from '@/apps/data-platform/services/master_data/role_service';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import { bulkLoadMixin } from '@/mixins/bulk_load';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import XLSX from 'xlsx';
import { LIST_ROLES, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import { mapState } from 'vuex';
export default {
  name: 'RolesPage',
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      valid2: false,
      csvFile: null,
      attributesMarketplaceRoles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_SUPERVISOR],
      customerInsightsRoles: [ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER],
      digitalAudiencesRoles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST],
      assessmentRoles: [ROLES_LIST.ASSESSMENT_USER],
      adminRoles: [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.INSIGHTS_ADMIN],
      valid: false,
      filters: {},
      datos: [],
      selectRols: Object.assign([], LIST_ROLES),
      selectBusinessDomain: [],
      selectBusinessSubdomain: [],
      pagination: {
        limit: 10,
        current: 1,
        total: 0
      },
      pagination_massive: {
        limit: 10,
        current: 1,
        total: 0
      },
      filter_enabled: true,
      key_pagination: 1,
      mode: 'new',
      user_edit: {
        roles: []
      },
      key_roles: 1,
      menuPicker: [],
      business_domain: {},
      modal_usuario: 'fcre-modal',
      rules: {
        email: [function (v) {
          return !!v || 'El campo es requerido';
        }, function (v) {
          return PATTERNS_VALIDATION.EMAIL_GENERAL.test(v) || 'Ingrese un correo electrónico válido.';
        }]
      },
      list_orgs: [],
      users_download: [],
      item_delete: null,
      load_users: [],
      key_roles_massive: 1
    };
  },
  mixins: [bulkLoadMixin],
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'orgs', 'isDomainItc'])), {}, {
    fields: function fields() {
      return [{
        value: 'domain',
        text: this.traductor('tablas.organization'),
        sortable: true,
        align: 'center'
      }, {
        value: 'email',
        text: this.traductor('tablas.user_email'),
        sortable: true,
        align: 'left'
      },
      // {value: 'user_role', text: this.traductor('tablas.user_roles')},
      {
        text: this.traductor('tablas.user_roles'),
        value: 'roles',
        width: 300,
        align: 'left'
      }, {
        text: this.traductor('tablas.actions'),
        value: 'actions',
        align: 'center'
      }];
    },
    fields_massive: function fields_massive() {
      return [{
        value: 'domain',
        text: this.traductor('tablas.organization'),
        sortable: true,
        align: 'center'
      }, {
        value: 'email',
        text: this.traductor('tablas.user_email'),
        sortable: true,
        align: 'left'
      }, {
        text: this.traductor('tablas.user_roles'),
        value: 'roles',
        width: 300,
        align: 'left'
      }, {
        text: this.traductor('tablas.actions'),
        value: 'actions',
        align: 'center'
      }, {
        text: this.traductor('tablas.observation'),
        value: 'observation'
      }];
    },
    role_fields: function role_fields() {
      return [{
        value: 'role',
        text: this.traductor('tablas.rol'),
        sortable: true,
        align: 'center'
      }, {
        value: 'expired_date',
        text: this.traductor('tablas.expiration_date'),
        sortable: true,
        align: 'center'
      }, {
        value: 'navigator',
        text: this.traductor('tablas.actions'),
        width: 300,
        align: 'center'
      }];
    },
    log_field: function log_field() {
      return [{
        key: 'created_by',
        label: this.traductor('tablas.created_by'),
        sortable: true,
        align: 'center'
      }, {
        key: 'created_date',
        label: this.traductor('tablas.creation_time'),
        sortable: true,
        align: 'center'
      }, {
        key: 'role',
        label: this.traductor('tablas.rol'),
        sortable: true,
        align: 'center'
      }, {
        key: 'type',
        label: this.traductor('tablas.type'),
        sortable: true,
        align: 'center'
      }];
    },
    fieldsRoles: function fieldsRoles() {
      return [{
        text: this.traductor('roles.tabla_roles.rol'),
        value: 'rol'
      }, {
        text: this.traductor('roles.tabla_roles.activo'),
        value: 'flag_active'
      }, {
        text: this.traductor('roles.tabla_roles.expiracion'),
        value: 'expired_date'
      }, {
        text: this.traductor('roles.tabla_roles.domain') + " & " + this.traductor('roles.tabla_roles.subdomain'),
        value: 'domain'
      }, {
        text: this.traductor('roles.tabla_roles.acciones'),
        value: 'actions'
      }];
    },
    load_csv: function load_csv() {
      return this.traductor('my_tasks.upload_csv');
    },
    modalName: function modalName() {
      return this.traductor('menu.config.data_governance');
    },
    labels: function labels() {
      return {
        domain: this.traductor('filtros.organization'),
        user: this.traductor('tablas.user'),
        from: this.traductor('form_audiencia.desde'),
        to: this.traductor('form_audiencia.hasta'),
        user_address: this.traductor('tablas.user_email'),
        user_roles: this.traductor('tablas.user_roles'),
        search_tags: this.traductor('frases.search_tags'),
        activate: this.traductor('filtros.activate'),
        expired_date: this.traductor('tablas.expiration_date'),
        subdomain: this.traductor('filtros.subdomain'),
        delete_rol: this.traductor('frases.delete_rol'),
        search_email: this.traductor('frases.search_email'),
        advanced_search: this.traductor('botones.boton_busqueda_avanzada')
      };
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    criteria: function criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions: function availableOptions() {
      var _this = this;
      // Si el parámetro que le llega es null, signficia que queremos todas las opciones disponibles
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (item) {
          // Significa que se ha añadido un item en la tabla, se le manda este parámetro para que se actualice la lista de opcione disponibles.
          var selectRols = _this.selectRols.filter(function (rol) {
            return _this.user_edit.roles.findIndex(function (item) {
              return item.rol === rol;
            }) === -1;
          });
          if (item.rol) {
            // Si tiene rol, signficia que se quier asignar. Debemos ponerlo en el listado para que el select reconozca la opción seleccionada.
            selectRols.push(item.rol);
          }
          return selectRols;
        } else {
          return _this.selectRols;
        }
      };
    },
    filterSubdomain: function filterSubdomain() {
      var _this2 = this;
      return function (param) {
        var selectBusinessSubdomain = _this2.selectBusinessSubdomain.filter(function (Subdomain) {
          return Subdomain.kdomain.includes(param);
        });
        return selectBusinessSubdomain;
      };
    },
    /* avalOptSearch() {
      return this.selectRols.filter(opt => this.selectedSearchRoles.indexOf(opt) === -1)
    },*/
    isAudienceAdmin: function isAudienceAdmin() {
      return window.userInfo.userRoles.includes(ROLES_LIST.AUDIENCE_ADMIN);
    },
    selectDomain: function selectDomain() {
      var orgs = [window.userInfo.domain];
      for (var i in window.userInfo.listOrgs) {
        orgs.push(window.userInfo.listOrgs[i]);
      }
      return orgs;
    },
    isServiceManager: function isServiceManager() {
      return window.userInfo.userRoles.includes(ROLES_LIST.SERVICE_MANAGER);
    },
    isInsightServiceManager: function isInsightServiceManager() {
      return window.userInfo.userRoles.includes(ROLES_LIST.INSIGHTS_SERVICE_MANAGER);
    },
    isOrgDataManagement: function isOrgDataManagement() {
      return window.userInfo.userRoles.includes(ROLES_LIST.ORG_DATA_STEWARD);
    },
    getRegistrosValidos: function getRegistrosValidos() {
      return this.load_users.filter(function (x) {
        return x.observations.length == 0;
      }).length;
    }
  }),
  created: function created() {
    this.filters.select_domain = window.userInfo.domain;
    this.listarUsuarios();
    this.loadDomainsSubdomains(this.filters.select_domain);
    this.getListOrgs();
  },
  methods: {
    openDownloadDialog: function openDownloadDialog() {
      if (window.userInfo.domain == "intercorp.com.pe") {
        this.$refs.dialogConfirmation.onOpen();
      } else {
        this.onConfirm(false);
      }
    },
    downloadLiteCSV: function downloadLiteCSV() {
      var _this3 = this;
      var dataToExport = [];
      this.users_download.forEach(function (user) {
        user.roles.forEach(function (roleArray) {
          var mappedUser = _this3.mapUsers(user, roleArray[0]);
          dataToExport.push(mappedUser);
        });
      });
      var data = XLSX.utils.json_to_sheet(dataToExport);
      var csvData = XLSX.utils.sheet_to_csv(data, {
        FS: ';'
      });
      var today = new Date().toISOString().substring(0, 10);
      var fileName = "data-platform-roles-".concat(today, ".csv");
      tasks.saveData(csvData, fileName);
      this.$refs["dialogConfirmation"].onClose();
    },
    mapUsers: function mapUsers(user, role) {
      return {
        domain: user.domain,
        user: user.email,
        rol: role
      };
    },
    mapOnlyUsers: function mapOnlyUsers(user) {
      return {
        domain: user.domain,
        email: user.email
      };
    },
    onConfirm: function onConfirm(event) {
      var _this4 = this;
      var clauses = {};
      if (this.filters.user) {
        clauses.user = this.filters.user;
      }
      if (this.filters.roles) {
        clauses.roles = this.filters.roles;
      }
      //console.log("domain:",this.filters.select_domain)
      var parametros = {
        domain: this.filters.select_domain,
        clauses: clauses,
        allDomains: event
      };
      rolesService.DownloadUsers(parametros).then(function (response) {
        //console.log('dbug', response.data)
        _this4.users_download = response.data.result;
        _this4.downloadLiteCSV();
      });
    },
    getListOrgs: function getListOrgs() {
      var _this5 = this;
      domain_service.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this5.list_orgs = response.data;
        }
      });
    },
    canEdit: function canEdit(item) {
      if (this.availableOptions().filter(function (x) {
        return x == item.rol;
      }).length > 0) {
        return true;
      }
      return false;
    },
    rolesEditados: function rolesEditados() {
      if (this.user_edit.roles) {
        if (this.user_edit.roles.filter(function (x) {
          return x.edit == true;
        }).length > 0) {
          return true;
        }
      }
      return false;
    },
    getMode: function getMode() {
      if (this.mode == 'view') {
        return 'Ver';
      }
      if (this.mode == 'edit') {
        return 'Editar';
      }
      if (this.mode == 'new') {
        return 'Nueva';
      }
    },
    onChangeDomain: function onChangeDomain() {
      if (this.mode == 'new') {
        this.user_edit.roles.forEach(function (rol) {
          rol.rol = null;
          rol.ownership = [];
        });
      }
      this.getRolesToAssign(this.user_edit);
      this.loadDomainsSubdomains(this.user_edit.domain);
      this.key_roles += 1;
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onResetBusinessDomain: function onResetBusinessDomain() {
      this.business_domain = {};
    },
    onAddBusinessDomain: function onAddBusinessDomain(index, flag) {
      var _this6 = this;
      //console.log(this.business_domain, index)
      if (!this.business_domain.domain) {
        this.$toast.warning('Seleccione un dominio');
        return;
      }
      if (!this.business_domain.subdomain) {
        this.$toast.warning('Seleccione un subdominio');
        return;
      }
      var domain = this.selectBusinessDomain.find(function (x) {
        return x.value == _this6.business_domain.domain;
      });
      var subdomain = this.filterSubdomain(this.business_domain.domain).find(function (x) {
        return x.value == _this6.business_domain.subdomain;
      });
      var obj = {};
      if (domain) {
        obj = {
          business_domain: {
            domain: domain.text,
            kdomain: domain.value
          },
          business_subdomain: {
            subdomain: subdomain.text,
            ksubdomain: subdomain.value
          }
        };
      }
      if (!Object.keys(this.user_edit.roles[index]).includes('ownership')) {
        this.user_edit.roles[index].ownership = [];
      }
      this.user_edit.roles[index].ownership.push(obj);
      this.key_roles += 1;
      flag = false;
    },
    onEditRow: function onEditRow(item) {
      //console.log('Edit')
      item.edit = !item.edit;
      this.key_roles += 1;
    },
    onDeleteRow: function onDeleteRow(index) {
      this.user_edit.roles.splice(index, 1);
      this.key_roles += 1;
    },
    onRemoveBusinessDomain: function onRemoveBusinessDomain(index, index2) {
      this.user_edit.roles[index].ownership.splice(index2, 1);
      this.key_roles += 1;
    },
    listarUsuarios: function listarUsuarios() {
      var _this7 = this;
      var clauses = {};
      if (this.filters.user) {
        clauses.user = this.filters.user;
      }
      if (this.filters.roles) {
        clauses.roles = this.filters.roles;
      }
      //console.log("domain:",this.filters.select_domain)
      var parametros = {
        domain: this.filters.select_domain,
        limit: this.pagination.limit,
        page: this.pagination.current,
        clauses: clauses
      };
      rolesService.getRoles(parametros).then(function (response) {
        //console.log('dbug', response.data)
        if (response.data.result) {
          if (response.data.result.length > 1) {
            //console.log("has next", response.data.result.length)
            _this7.pagination.next = true;
          } else {
            //console.log("no has next", response.data.result.length)
            _this7.pagination.next = false;
          }
          _this7.pagination.total = response.data.result.length;
          _this7.key_pagination += 1;
          _this7.datos = response.data.result;
          if (JSON.stringify(_this7.datos).startsWith('[')) {
            _this7.datos.forEach(function (x) {
              x.domain = _this7.filters.select_domain + '';
            });
          } else {
            _this7.datos = [];
          }
        } else {
          _this7.pagination.next = false;
          _this7.pagination.total = 0;
          _this7.key_pagination += 1;
          _this7.datos = [];
        }
      });
    },
    newUser: function newUser() {
      this.mode = 'new';
      this.user_edit = {
        roles: []
      };
      this.user_edit.domain = window.userInfo.domain;
      this.getRolesToAssign(this.user_edit);
      this.onChangeDomain();
      this.$refs[this.modal_usuario].onOpen();
    },
    onBuscar: function onBuscar() {
      this.loadDomainsSubdomains(this.filters.select_domain);
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.listarUsuarios();
    },
    onLimpiar: function onLimpiar() {
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.loadDomainsSubdomains(this.filters.select_domain);
      this.filters = {
        select_domain: this.filters.select_domain,
        user: null,
        roles: []
      };
      this.listarUsuarios();
    },
    onEdit: function onEdit(item) {
      this.mode = 'edit';
      //console.log(item)
      var item_copy = Object.assign({}, item);
      var roles = [];
      item_copy.roles.forEach(function (rol) {
        var r = {
          expired_date: rol[1].expired_date,
          flag_active: rol[1].flag_active,
          ownership: rol[1].ownership ? rol[1].ownership : [],
          rol: rol[0]
        };
        roles.push(r);
      });
      var edit = {
        domain: item_copy.domain,
        email: item_copy.email,
        roles: roles
      };
      this.user_edit = Object.assign({}, edit);
      this.getRolesToAssign(this.user_edit);
      this.onChangeDomain();
      this.$refs[this.modal_usuario].onOpen();
    },
    changePagina: function changePagina(page) {
      this.listarUsuarios();
    },
    onGuadarUsuario: function onGuadarUsuario() {
      var _this8 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.mode == 'new') {
        var roles = {};
        this.user_edit.roles.forEach(function (rol) {
          roles[rol.rol] = {
            email: _this8.user_edit.email,
            expired_date: rol.expired_date,
            flag_active: rol.flag_active,
            ownership: rol.ownership ? rol.ownership : [],
            params: null
          };
        });
        var param = {
          data: {
            domain: this.user_edit.domain,
            email: this.user_edit.email,
            roles: roles
          }
        };
        //console.log(param)
        rolesService.create_user(param).then(function (response) {
          if (response.success) {
            tasks.toast.success('El usuario se guardo correctamente.');
            _this8.$refs[_this8.modal_usuario].onClose();
            _this8.listarUsuarios();
          } else {
            tasks.toast.error(response.message);
          }
        });
      } else {
        var _roles = {};
        this.user_edit.roles.forEach(function (rol) {
          _roles[rol.rol] = {
            email: _this8.user_edit.email,
            expired_date: rol.expired_date,
            flag_active: rol.flag_active,
            ownership: rol.ownership ? rol.ownership : [],
            params: null
          };
          if (rol.edit) {
            _roles[rol.rol]['edit'] = true;
          }
        });
        var _param = {
          data: {
            domain: this.user_edit.domain,
            email: this.user_edit.email,
            roles: _roles
          }
        };
        //console.log(param)
        rolesService.edit_user(_param).then(function (response) {
          if (response.success) {
            tasks.toast.success('El usuario se guardo correctamente.');
            _this8.$refs[_this8.modal_usuario].onClose();
            _this8.listarUsuarios();
          } else {
            tasks.toast.error(response.message);
          }
        });
      }
    },
    onAddRol: function onAddRol() {
      if (!Object.keys(this.user_edit).includes('roles')) {
        this.user_edit.roles = [];
      }
      if (this.mode === 'new') {
        this.user_edit.roles.push({
          edit: true,
          flag_active: true
        });
      } else {
        this.user_edit.roles.push({
          edit: true,
          flag_active: true
        });
      }
      this.menuPicker.push(false);
      this.key_roles += 1;
      //console.log(this.user_edit)
    },
    loadDomainsSubdomains: function loadDomainsSubdomains(domain) {
      var _this9 = this;
      var businessDomain = {
        domain: domain
      };
      businessDomainService.getBusinessDomains(businessDomain).then(function (response) {
        _this9.selectBusinessDomain = [];
        _this9.selectBusinessDomain.push({
          value: 'Organization',
          text: 'Organization'
        });
        for (var i = 0; i < response.data.result.length; i++) {
          _this9.selectBusinessDomain.push({
            value: response.data.result[i].kdomain,
            text: response.data.result[i].domain
          });
        }
        businessSubdomainService.getBusinessSubdomains(businessDomain).then(function (response) {
          _this9.selectBusinessSubdomain = [];
          _this9.selectBusinessSubdomain.push({
            kdomain: 'Organization',
            value: 'Organization',
            text: 'Organization'
          });
          for (var _i = 0; _i < response.data.result.length; _i++) {
            _this9.selectBusinessSubdomain.push({
              kdomain: response.data.result[_i].kdomain,
              value: response.data.result[_i].ksubdomain,
              text: response.data.result[_i].subdomain
            });
          }
        });
      });
    },
    getRolesToAssign: function getRolesToAssign() {
      var _this0 = this;
      var userEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Se toma como referencia el dominio, ya sea del usuario a signar o del usuario de la plataforma
      var domainAssign = userEdit && userEdit.domain ? userEdit.domain : this.userDomain;
      // Se guarda si este dominio es Intercorp
      var isItcDomain = domainAssign === 'intercorp.com.pe';
      var rolesToAssign = [];
      this.userInfo.userRoles.forEach(function (role) {
        var _roles2;
        var roles = [];
        switch (role) {
          case ROLES_LIST.ORG_DATA_STEWARD:
            roles = LIST_ROLES;
            if (!isItcDomain) {
              // En caso que no sea Intercorp, hay dos casos:
              if (domainAssign === _this0.userDomain) {
                // El primero que sea un ORG_DATA_STEWARD en el dominio que se desea asignar el rol(Debería mostrarle todos los roles menos los administrativos)
                _this0.adminRoles.forEach(function (role) {
                  var index = roles.indexOf(role);
                  if (index !== -1) {
                    roles.splice(index, 1);
                  }
                });
              } else {
                // Que no sea ORG_DATA_STEWARD en el dominio que se desea asignar el rol
                roles = [];
              }
            }
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case "support_developer":
            roles = LIST_ROLES;
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.SERVICE_MANAGER:
            roles = [];
            (_roles2 = roles).push.apply(_roles2, _toConsumableArray(LIST_ROLES));
            //console.log("hola", roles)
            var index = roles.indexOf(ROLES_LIST.ORG_DATA_STEWARD);
            roles.splice(index, 1);
            index = roles.indexOf(ROLES_LIST.AUDIENCE_ADMIN);
            roles.splice(index, 1);
            index = roles.indexOf(ROLES_LIST.INSIGHTS_ADMIN);
            roles.splice(index, 1);
            index = roles.indexOf(ROLES_LIST.ATTRIBUTE_ADMIN);
            roles.splice(index, 1);
            index = roles.indexOf(ROLES_LIST.ASSESSMENT_ADMIN);
            roles.splice(index, 1);
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.INSIGHTS_SERVICE_MANAGER:
            rolesToAssign.push(ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER);
            rolesToAssign.push(ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER);
            rolesToAssign.push(ROLES_LIST.INSIGHTS_USER_SOMOS1);
            break;
          case ROLES_LIST.AUDIENCE_ADMIN:
            roles = _this0.isDomainItc ? _this0.digitalAudiencesRoles : [];
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.AUDIENCE_ANALYST:
            roles = _this0.digitalAudiencesRoles;
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.ATTRIBUTE_ADMIN:
            roles = _this0.isDomainItc ? _this0.attributesMarketplaceRoles : [];
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.ATTRIBUTE_SUPERVISOR:
            roles = _this0.attributesMarketplaceRoles.filter(function (attributeRole) {
              return attributeRole !== role;
            });
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.INSIGHTS_ADMIN:
            roles = _this0.isDomainItc ? _this0.customerInsightsRoles : [];
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
          case ROLES_LIST.ASSESSMENT_ADMIN:
            roles = _this0.isDomainItc ? _this0.assessmentRoles : [];
            rolesToAssign.push.apply(rolesToAssign, _toConsumableArray(roles));
            break;
        }
      });
      // Se eliminan los repetidos
      this.selectRols = _toConsumableArray(new Set(rolesToAssign));
    },
    onDelete: function onDelete(item) {
      this.item_delete = Object.assign({}, item);
      this.$refs["dialogConfirmationDelete"].onOpen();
    },
    onConfirmDelete: function onConfirmDelete(event) {
      var _this1 = this;
      if (event) {
        this.$refs["dialogConfirmationDelete"].onClose();
        rolesService.deleteUser(this.item_delete.email, this.filters.select_domain).then(function (response) {
          console.log(response);
          if (response.success) {
            tasks.toast.success("El usuario se eliminó correctamente.");
            _this1.onLimpiar();
          } else {
            tasks.toast.error("No se pudo eliminar el usuario, intentelo en unos minutos.");
          }
          _this1.item_delete = null;
        });
      } else {
        this.item_delete = null;
        this.$refs["dialogConfirmationDelete"].onClose();
      }
    },
    massiveUploadUsers: function massiveUploadUsers() {
      this.load_users = [];
      this.key_roles_massive += 1;
      this.user_edit.domain = window.userInfo.domain;
      this.getRolesToAssign();
      this.$refs["modal_carga_masiva_usuarios"].onOpen();
    },
    onLoadFile: function onLoadFile(event) {
      var _this10 = this;
      console.log(event);
      if (!event) return;
      this.load_users = [];
      this.resetPaginationMassive();
      this.key_roles_massive += 1;
      var reader = new FileReader();
      reader.readAsText(this.csvFile, 'ISO-8859-1');
      reader.onload = function (e) {
        var header = "email;roles".split(';');
        var body = _this10.getBodyJson(e);
        var records = [];
        var _iterator = _createForOfIteratorHelper(body),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var body_item = _step.value;
            var record = {
              observations: []
            };
            var _loop = function _loop() {
                var property = header[index].trim();
                var row = body_item[property];
                if (header.includes(property)) {
                  if (property == "roles") {
                    // validar roles permitidos
                    var roles = row ? row.trim().split(",") : [];
                    var validos = [];
                    var no_validos = [];
                    roles.forEach(function (r) {
                      if (_this10.validarRolPermitido(r)) {
                        validos.push(r);
                      } else {
                        no_validos.push(r);
                      }
                    });
                    record[property] = validos;
                    if (no_validos.length > 0) record["observations"].push("Roles no válidos o no permitidos: " + no_validos.join(", ") + ".");
                  } else if (property == "email") {
                    // validar formato email
                    var email = row ? row.trim() : '';
                    emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailRegex.test(email)) record[property] = email;else {
                      record[property] = email;
                      record["observations"].push("Email " + email + " no válido.");
                    }
                  }
                }
              },
              emailRegex;
            for (var index in header) {
              _loop();
            }
            records.push(record);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        console.log(records);
        _this10.load_users = Object.assign([], records);
        _this10.csvFile = null;
      };
    },
    validarRolPermitido: function validarRolPermitido(rol) {
      if (this.selectRols.includes(rol)) return true;else return false;
    },
    onDeleteRowMassive: function onDeleteRowMassive(index) {
      this.load_users.splice(index, 1);
      this.key_roles_massive += 1;
    },
    onDownloadTemplate: function onDownloadTemplate() {
      var csvData = "data:text/csv;charset=utf-8,email;roles";
      var encodedUri = encodeURI(csvData);
      // Trick to set filename
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "template_users.csv");
      document.body.appendChild(link); // Required for Firefox(?)
      link.click();
    },
    onGuadarUsuariosMasivo: function onGuadarUsuariosMasivo() {
      var _this11 = this;
      if (this.getRegistrosValidos == 0) {
        tasks.toast.error("Debe cargar registros válidos.");
        return;
      }
      var users_valid = this.load_users.filter(function (x) {
        return x.observations.length == 0;
      });
      rolesService.massiveUser(users_valid, this.user_edit.domain).then(function (response) {
        if (response.success) {
          tasks.toast.success("Los registros se guardaron correctamente.");
          _this11.load_users = [];
          _this11.key_roles_massive += 1;
          _this11.$refs["modal_carga_masiva_usuarios"].onClose();
          _this11.onLimpiar();
        } else {
          tasks.toast.error("No se pudo guardar los registros.");
        }
      });
    },
    resetPaginationMassive: function resetPaginationMassive() {
      this.pagination_massive = {
        limit: 10,
        total: 0,
        current: 1
      };
    }
  }
};